import * as React from 'react';

import { IBankDesktopSchema } from '../../repositories/newbuilding-card/entities/newbuilding/BankDesktopSchema';
import { BankListItem } from './components/BankListItem';

import * as styles from './AccreditedBanks.css';

export interface IAccreditedBanksProps {
  banks: IBankDesktopSchema[];
  onBankClick?(bank: IBankDesktopSchema): void;
}

export const AccreditedBanks: React.FC<IAccreditedBanksProps> = ({ banks, onBankClick }) => {
  return (
    <ul className={styles['list']} data-testid="AccreditedBanks">
      {banks.map(bank => (
        <li key={bank.id}>
          <BankListItem bank={bank} onLinkClick={onBankClick} />
        </li>
      ))}
    </ul>
  );
};
